import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Nav, Tab } from "react-bootstrap";
import { 
    FilePdfOutlined, 
    UploadOutlined, 
    FolderOpenOutlined, 
    ThunderboltOutlined, 
    HistoryOutlined, 
    FontSizeOutlined,
} from "@ant-design/icons";

function PdfParserMain() {
    const location = useLocation();
    const navigate = useNavigate();

    // Extract the last segment of the pathname
    const pathSegments = location.pathname.split("/").filter(Boolean);
    let activeKey = pathSegments[pathSegments.length - 1]?.toLowerCase() || "upload";

    // Handle the base path
    if (activeKey === "pdf-parser") {
        activeKey = "upload";
    }

    function handleSelect(key) {
        if (key === "upload") {
            navigate("/pdf-parser");
        } else if (key === "templates") {
            navigate("/pdf-parser/templates");
        } else if (key === "generate") {
            navigate("/pdf-parser/generate");
        } else if (key === "history") {
            navigate("/pdf-parser/history");
        } else if (key === "fonts") {
            navigate("/pdf-parser/fonts");
        }
    }

    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Header Section */}
                <div 
                    className="mb-4 pb-3" 
                    style={{ 
                        borderBottom: "2px solid #e8e8e8",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div className="d-flex align-items-center gap-3">
                        <div 
                            style={{ 
                                width: 48, 
                                height: 48, 
                                borderRadius: 10,
                                background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 4px 12px rgba(26, 26, 46, 0.15)"
                            }}
                        >
                            <FilePdfOutlined style={{ fontSize: 24, color: "#fff" }} />
                        </div>
                        <div>
                            <h2 className="mb-0" style={{ 
                                color: "#1a1a2e", 
                                fontWeight: 700,
                                fontSize: "1.75rem",
                                letterSpacing: "-0.5px"
                            }}>
                                PDF Parser
                            </h2>
                            <p className="mb-0" style={{ color: "#6c757d", fontSize: "0.9rem" }}>
                                Batch personalize PDFs with dynamic placeholders
                            </p>
                        </div>
                    </div>
                </div>

                <Tab.Container activeKey={activeKey} onSelect={handleSelect}>
                    <Nav 
                        variant="tabs" 
                        style={{ 
                            marginBottom: "1.5rem",
                            borderBottom: "2px solid #e8e8e8"
                        }}
                    >
                        <Nav.Item>
                            <Nav.Link 
                                eventKey="upload"
                                style={{ 
                                    fontWeight: 500,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "0.75rem 1.25rem"
                                }}
                            >
                                <UploadOutlined />
                                Upload
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link 
                                eventKey="templates"
                                style={{ 
                                    fontWeight: 500,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "0.75rem 1.25rem"
                                }}
                            >
                                <FolderOpenOutlined />
                                Templates
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link 
                                eventKey="generate"
                                style={{ 
                                    fontWeight: 500,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "0.75rem 1.25rem"
                                }}
                            >
                                <ThunderboltOutlined />
                                Generate
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link 
                                eventKey="history"
                                style={{ 
                                    fontWeight: 500,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "0.75rem 1.25rem"
                                }}
                            >
                                <HistoryOutlined />
                                History
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link 
                                eventKey="fonts"
                                style={{ 
                                    fontWeight: 500,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding: "0.75rem 1.25rem"
                                }}
                            >
                                <FontSizeOutlined />
                                Fonts
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey={activeKey} active>
                            <Outlet />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div>
        </div>
    );
}

export default PdfParserMain;
